import type { SxProps } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import type { Moment } from 'moment';
import moment from 'moment';

interface DateFieldProps {
    label: string;
    value: Date | null;
    onChange: (value: Date | null) => void;
    required?: boolean;
    disabled?: boolean;
    /** Keeps the label for assistive tech only, e.g. when a table header already names the column. */
    hideLabel?: boolean;
    size?: 'small' | 'medium';
    fullWidth?: boolean;
    sx?: SxProps;
}

/**
 * Date-only picker for gift planning.
 */
export const DateField = ({
    label,
    value,
    onChange,
    required,
    disabled,
    hideLabel = false,
    size = 'small',
    fullWidth = true,
    sx,
}: DateFieldProps) => {
    const parsed = value ? moment(value) : null;

    return (
        <DatePicker
            label={hideLabel ? undefined : label}
            value={parsed}
            format="YYYY-MM-DD"
            disabled={disabled}
            onChange={(next: Moment | null) =>
                onChange(next ? next.toDate() : null)
            }
            slotProps={{
                textField: {
                    required,
                    size,
                    fullWidth,
                    sx,
                    ...(hideLabel && {
                        InputProps: { 'aria-label': label },
                        inputProps: { 'aria-label': label },
                    }),
                },
            }}
        />
    );
};
